module.exports = __webpack_public_path__ + "img/logo.8052b48f.png";